/* Documents */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.reviewDocument {
  display: inline-flex;
  flex-direction: row;
  margin-left: 1rem;
  margin-bottom: 0.6rem;
  border: 1px solid #367c2b;
  border-left: 4px solid #367c2b;
  border-radius: 7px;
  padding: 5px 3px 5px 1px;
}

.reviewDocument > span {
  margin-left: 3px;
  margin-right: 6px;
  font-size: 1rem;
}

/* Signers */
.signerReview {
  display: flex;
  flex-direction: row;
  border: 1px solid #367c2b;
  border-left: 4px solid #367c2b;
  border-radius: 10px;
  margin-bottom: 1rem;
  margin-left: 5%;
  align-items: center;
}

.signerReviewError {
  display: flex;
  flex-direction: row;
  border: 1px solid #d24625;
  border-left: 4px solid #d24625;
  border-radius: 10px;
  margin-bottom: 1rem;
  margin-left: 5%;
  align-items: center;
}
.signerReview .reviewAvatar {
  font-size: 350%;
  margin-top: 1%;
  margin-left: 2%;
  color: #367c2b;
  opacity: 0.5 !important;
}

.signerReviewError .reviewAvatar {
  font-size: 350%;
  margin-top: 1%;
  margin: 0 2%;
  color: #d24625;
  opacity: 0.5 !important;
}

.signerReview .signerReviewDiv,
.signerReviewError .signerReviewDiv {
  margin-left: 0.5rem;
  width: 85%;
}

.signerReview .signerReviewInfo,
.signerReviewError .signerReviewInfo {
  margin-top: 2%;
  margin-left: 1%;
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  font-weight: bold;
  padding-bottom: 2%;
}
.signerReview p,
.signerReviewError P {
  margin-bottom: 1%;
}
.signerReview span,
.signerReviewError span {
  font-size: 0.8rem;
  font-weight: normal;
  margin-top: 2px;
  margin-bottom: 3px;
}

.signerReview .signerOptionsReview,
.signerReviewError .signerOptionsReview {
  display: flex;
  flex-direction: column;
}

.signerReviewInfo .reviewOrder {
  display: flex;
}
